import {
  setCycles,
  setReportAll,
  setReportAllCMCS,
  setNextContentsStudent,
  setPreviousContentsStudent,
  setCurrentCycleAndLevelStudent,
} from "../slices/methodology.slice";
import api from "../../services/api";
import { initLoading, endLoading } from "../slices/generics.slice";

const URL_CLASS = "/classSchedulesForm";
const URL_STUDENT_MANAGER = "/studentManagement";
const URL_CYCLE_AND_LEVEL = "/cycleByLevelAndLanguage";
const URL_CURRENT_CYCLE_AND_LEVEL = "/getCurrentCycleAndLevelByStudentId";

export const getFormByFilter = (body, loading = true) => {
  return async (dispatch) => {
    dispatch(setReportAll([]));
    loading && (await dispatch(initLoading()));

    try {
      const response = await api.post(`${URL_CLASS}/getFormByFilter`, JSON.stringify(body));

      if (response.data.success) {
        const resp = Object.values(response.data.result.items[0]);

        dispatch(setReportAll(resp));
        return resp;
      } else {
        dispatch(setReportAll([]));
      }
    } catch (error) {
      console.log("getFormByFilter", error);
      throw error;
    } finally {
      loading && (await dispatch(endLoading()));
    }
  };
};

export const getPreviousContentsOfStudent = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`${URL_CLASS}/getPreviousContentsOfStudent`, JSON.stringify(body));
      dispatch(setPreviousContentsStudent(response.data.result.items));
    } catch (error) {
      console.log("getPreviousContentsOfStudent", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getNextContentsOfStudent = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`${URL_CLASS}/getNextContentsOfStudent`, JSON.stringify(body));
      const newResponse = response.data.result.items
        .filter((item) => item !== null)
        .map((item) => {
          if (item.contentExists) {
            return {
              ...item,
              checkbox: true,
              pageFinished: item.contentExistsData[0].pageFinished,
              continueComment: item.contentExistsData[0].continueComment,
              classNotCompleted: !!item.contentExistsData[0].pageFinished,
            };
          }
          return { ...item, checkbox: false };
        });

      dispatch(setNextContentsStudent(newResponse));
    } catch (error) {
      console.log("getNextContentsOfStudent", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putFillForm = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`${URL_CLASS}/fillForm`, JSON.stringify(body));
      return response.data.result.items;
    } catch (error) {
      console.log("putFillForm", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const putUpdateFilledForm = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`${URL_CLASS}/updateFilledForm`, JSON.stringify(body));
      return response.data.result.items;
    } catch (error) {
      console.log("putUpdateFilledForm", error.response);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const createCommentForCoordinator = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`${URL_CLASS}/createCommentForCoordinator`, JSON.stringify(body));
      return response.data.result.items;
    } catch (error) {
      console.log("putFillForm", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const createStudentLevelGrade = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.post(`${URL_STUDENT_MANAGER}/createStudentLevelGradeArray`, JSON.stringify(body));

      return response.data.success;
    } catch (error) {
      console.log("createStudentLevelGrade", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const updateStudentLevelGrade = (body) => {
  return async (dispatch) => {
    dispatch(initLoading());

    try {
      const response = await api.put(`${URL_STUDENT_MANAGER}/updateStudentLevelGrade`, JSON.stringify(body));

      return response.data.success;
    } catch (error) {
      console.log("updateStudentLevelGrade", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const cycleByLevelAndLanguage = (level, language) => {
  return async (dispatch) => {
    const LANG_MAP = { 1: "EN", 2: "ES", 3: "PT", 4: "FR", 101: "CS-US-IN" };

    try {
      dispatch(initLoading());

      const url = new URL(URL_CYCLE_AND_LEVEL, window.location.origin);
      url.searchParams.set("level", level);
      url.searchParams.set("language", LANG_MAP[language] || "EN");

      const response = await api.get(url.pathname + url.search);
      dispatch(setCycles(response.data.result.items));
    } catch (error) {
      console.log("cycleByLevelAndLanguage", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getCurrentCycleAndLevelByStudentId = (payload) => {
  return async (dispatch) => {
    const LANG_MAP = { 1: "EN", 2: "ES", 3: "PT", 4: "FR", 101: "CS-US-IN" };

    try {
      const url = new URL(URL_CURRENT_CYCLE_AND_LEVEL, window.location.origin);
      url.searchParams.set("studentId", payload.studentId);
      url.searchParams.set("language", LANG_MAP[payload.language] || "EN");

      const response = await api.get(url.pathname + url.search);
      dispatch(setCurrentCycleAndLevelStudent(response.data.result.items));
      return response.data.result.items;
    } catch (error) {
      console.error("getCurrentCycleAndLevelByStudentId", error);
      throw error;
    }
  };
};

export const getFormDashboard = (payload, loading = true) => {
  return async (dispatch) => {
    try {
      loading && dispatch(initLoading());

      const response = await api.post(`${URL_CLASS}/getFormDashboard`, JSON.stringify(payload));

      if (response.data.success) {
        dispatch(setReportAllCMCS(response.data.result.items));
      } else {
        dispatch(setReportAllCMCS([]));
      }
    } catch (error) {
      console.log("getFormDashboard", error);
      throw error;
    } finally {
      loading && dispatch(endLoading());
    }
  };
};

export const getFormDashboardDetails = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post(`${URL_CLASS}/getFormDashboardDetails`, JSON.stringify(payload));

      if (response.data.success) {
        return response.data.result.items;
      } else {
        return [];
      }
    } catch (error) {
      console.log("getFormDashboardDetails", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};

export const getRefreshActiveCampaign = () => {
  return async (dispatch) => {
    try {
      dispatch(initLoading());

      const response = await api.post(`${URL_CLASS}/refreshActiveCampaign`);

      if (response.data.success) {
        return response.data.result.items;
      }
    } catch (error) {
      console.log("getRefreshActiveCampaign", error);
      throw error;
    } finally {
      dispatch(endLoading());
    }
  };
};
